import React, { useEffect, useState, Suspense } from 'react';
import Preloader from './components/Preloader';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';

function Root() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Wait for DOM to be ready, then show app
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800); // Reduced from 2000ms to 800ms for better UX

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<Preloader />}>
        <App />
      </Suspense>
    </ErrorBoundary>
  );
}

export default Root;
